import React from "react";

const CookiePolicy = () => {
    return (
        <div className="legals-box">
            <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
            <p className="mb-6">Effective Date: 15/07/2025</p>

            <section className="mb-6">
                <p>
                    This Cookie Policy explains how Scrubmail s.r.o ("we", "our", or
                    "us") uses cookies and similar technologies when you visit our
                    website or use our services.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">1. What Are Cookies?</h2>
                <p>
                    Cookies are small text files stored on your device when you visit a
                    website. They help us remember your preferences, improve user
                    experience, and analyze how our site is used.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">2. Types of Cookies We Use</h2>
                <ul className="list-disc list-inside">
                    <li>
                        <strong>Necessary Cookies:</strong> Required for core functionality
                        such as authentication and secure login.
                    </li>
                    <li>
                        <strong>Performance Cookies:</strong> Help us understand how users
                        interact with our website using tools like Google Tag Manager.
                    </li>
                    <li>
                        <strong>Functional Cookies:</strong> Enable site features and
                        remember your settings and preferences.
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">3. Third-Party Cookies</h2>
                <p>
                    We may allow trusted third-party services such as Google to place
                    cookies for analytics and login functionality. These cookies are
                    governed by the respective third parties’ privacy policies.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">4. How to Control Cookies</h2>
                <p>
                    You can control or delete cookies through your browser settings. Most
                    browsers allow you to block or delete cookies by adjusting your
                    preferences. Disabling some cookies may impact the functionality of
                    our website.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">5. Changes to This Policy</h2>
                <p>
                    We may update this Cookie Policy from time to time. Any changes will
                    be posted on this page with a new effective date. Continued use of
                    our website indicates your acceptance of the updated policy.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">6. Contact Us</h2>
                <p>
                    If you have questions about our use of cookies, contact us at:
                </p>
                <ul className="mt-2">
                    <li>📧 Email: support@scrubmail.com</li>
                    <li>🏢 Address: Ja Som Bratislava 123, 85101 Bratislava, Slovakia</li>
                </ul>
            </section>
        </div>
    );
};

export default CookiePolicy;